// @flow
import * as React from 'react'
import type { RouterHistory } from 'react-router-dom'
import { withRouter } from 'framework'
import { segment } from 'util/analytics'

type Props = {
  children: React.Node,
  history: RouterHistory,
}

export default withRouter(
  class SegmentPager extends React.Component<Props> {
    componentDidMount = () => {
      this.props.history.listen(() => segment.page())
      segment.page()
    }

    render() {
      return this.props.children
    }
  },
)
